/** localStorage key for the last validated Jigsaw workspace origin. */
export const JIGSAW_WORKSPACE_URL_STORAGE_KEY = 'jigsaw_workspace_url';

export const OFFICE_PATH = '/office/';

/** Parameter name for the parent origin of the office dialog. */
export const OFFICE_DIALOG_PARENT_ORIGIN_PARAM = 'officeDialogParentOrigin';

/**
 * Parameter name for the landing page origin, passed to the office app so it
 * can send the task pane back here on sign out.
 */
export const OFFICE_LANDING_ORIGIN_PARAM = 'officeLandingOrigin';

/** Query flag the office app sets when it sends the task pane back after sign out. */
export const SIGNED_OUT_QUERY_PARAM = 'signedOut';
